import React from 'react'
// ////////////////////////////////////////////////////////////////// COMPONENTS
import Icon from './icon'
// ////////////////////////////////////////////////////////////////// FLOW TYPES

// ////////////////////////////////////////////////////////////////// IMPORT END
// /////////////////////////////////////////////////////////////////////////////

type Props = {
  id?: string
  title?: string
  className?: string
  onClick?: Function
  style?: Record<string, string | number>
  width?: number
}

const List = ({
  id,
  title,
  className,
  onClick,
  style,
  width,
}: Props): React.ReactElement => {
  return (
    <Icon
      id={id || 'icon-list'}
      sourceWidth={11}
      sourceHeight={12}
      title={title}
      className={className}
      onClick={onClick}
      style={style}
      viewBox="0 0 60 60"
      width={width}
    >
      <g strokeWidth="0">
        <path d="M9.23077 35.6044H19.0046V25.934H9.23077V35.6044ZM9.23077 47.6923H19.0046V38.022H9.23077V47.6923ZM9.23077 23.5165H19.0046V13.8461H9.23077V23.5165ZM21.448 35.6044H50.7695V25.934H21.448V35.6044ZM21.448 47.6923H50.7695V38.022H21.448V47.6923ZM21.448 13.8461V23.5165H50.7695V13.8461H21.448Z" />
      </g>
    </Icon>
  )
}

// /////////////////////////////////////////////////////////////////////////////
// ////////////////////////////////////////////////////////////// EXPORT DEFAULT
export default List
